import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import RoutesList from '@/components/RoutesList.vue';
let LootPage = class LootPage extends Vue {
    get categories() {
        return [
            {
                category: '',
                routes: [
                    { to: '/loot/armor', title: 'Armor' },
                    { to: '/loot/weapons', title: 'Weapons' },
                    { to: '/loot/adventuringGear', title: 'Adventuring Gear' },
                    { to: '/loot/enhancedItems', title: 'Enhanced Items' }
                ]
            }
        ];
    }
};
LootPage = __decorate([
    Component({
        components: {
            RoutesList
        }
    })
], LootPage);
export default LootPage;
